import { Pipe, PipeTransform } from '@angular/core';
import { IMultiPrintDevice } from '@multiprint/abstract/multi-print-device';
import { statusTypes } from '@shared/constants/status-types';

@Pipe({
  name: 'multiPrintDeviceStatusFilter'
})
export class MultiPrintDeviceStatusFilterPipe implements PipeTransform {

  transform(value: IMultiPrintDevice[], statusCode: number): IMultiPrintDevice[] {
    var response = value;
    if (statusCode !== statusTypes.all) {
      response = value.filter(d => d.statusCode === statusCode);
    }

    return response;
  }
}
